/* eslint-disable react/prefer-stateless-function */
// Copyright (c) 2016 Deere & Company

import './dealer-recommendation-result.scss';
import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import DealerRecommendation from '@deere/cps-it.warranty-model-factory/lib/dealer-recommendation';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import RecommendationStatus from '../../shared/components/recommendation-status';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../services/dealer-recommendation-helper';
import {translate} from '../../../shared/services/translation-service';

class DealerRecommendationResult extends React.Component {

    componentWillMount() {

        this.setState({
            recommendationComments: this.props.dealerRecommendation.recommendation.responsibleAccountComments
        });

    }

    render() {

        return (
            <section className='dealer-recommendation-result'>
                <section>
                    <Checkbox
                        id={this.props.dealerRecommendation.id}
                        onChange={() => this.props.handleDealerChange(event)}
                        selected={this.props.initialState.includes(this.props.dealerRecommendation.id) || false}
                    >{''}</Checkbox>
                    <main>
                        <div className='product-header'>
                            <Link
                                className='product-title'
                                to={`/products/${this.props.dealerRecommendation.product.pin}`}
                            >
                                {this.props.dealerRecommendation.product.pin}
                            </Link>
                            {this.props.dealerRecommendation.recommendation.recommendationDate &&
                                <RecommendationStatus
                                    currentDate={Date.now()}
                                    recommendedDate={this.props.dealerRecommendation.recommendation.recommendationDate}
                                />
                            }
                        </div>
                        <div className='data-pairs'>
                            <div className='row'>
                                <LabeledString
                                    className='recommendation'
                                    data={this.props.dealerRecommendation.recommendation.recommendation}
                                    label='RECOMMENDATION'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='recommendation_date'
                                    data={buildDate(this.props.dealerRecommendation.recommendation.recommendationDate)}
                                    label='RECOMMENDATION_DATE'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='responsible_account'
                                    data={buildDealer(this.props.dealerRecommendation.currentDealer)}
                                    label='RESPONSIBLE_ACCOUNT'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='responsible_account'
                                    data={buildDealer(this.props.dealerRecommendation.newDealer)}
                                    label='RECOMMENDED_ACCOUNT'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='reason'
                                    data={this.props.dealerRecommendation.recommendation.reason}
                                    label='REASON'
                                />
                                <LabeledString
                                    className='model'
                                    data={this.props.dealerRecommendation.product.model}
                                    label='MODEL'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='customer'
                                    data={this.props.dealerRecommendation.product.customerSummary.displayName}
                                    label='CUSTOMER'
                                />
                                <LabeledString
                                    className='connected_machine'
                                    data={this.props.dealerRecommendation.recommendation.connectedMachine ? translate('YES') : translate('NO')}
                                    label='CONNECTED_MACHINE'
                                />
                            </div>
                            <div className='row'>
                                <LabeledString
                                    className='last_seen_at_responsible_account'
                                    data={buildDate(this.props.dealerRecommendation.recommendation.lastSeenAtResposibleAccount)}
                                    label='LAST_SEEN_AT_RESPONSIBLE_ACCOUNT'
                                />
                                <LabeledString
                                    className='estimated_hours'
                                    data={this.props.dealerRecommendation.recommendation.estimatedHours}
                                    label='ESTIMATED_HOURS'
                                />
                            </div>

                            <div className='row'>
                                <LabeledString
                                    className='distance_from_your_cog_location'
                                    data={this.props.dealerRecommendation.recommendation.distanceFromCogLocation}
                                    label='DISTANCE_FROM_RESPONSIBLE_ACCOUNT'
                                />
                            </div>
                        </div>
                    </main>
                </section>
            </section>
        );

    }

}

DealerRecommendationResult.displayName = 'DealerRecommendation';
DealerRecommendationResult.propTypes = {
    dealerRecommendation: PropTypes.instanceOf(DealerRecommendation).isRequired,
    handleDealerChange: PropTypes.func.isRequired,
    initialState: PropTypes.instanceOf(Array).isRequired,
    openDealerRecommendationModal: PropTypes.func.isRequired,
    uid: PropTypes.string.isRequired
};

export default DealerRecommendationResult;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-result.js